import { GridRowId } from '@mui/x-data-grid-pro';
import { IFieldValidations } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';

interface IPlaneringRequiredValidationRow {
  id: GridRowId;
  source?: 'planering' | 'aktivitet';
  isEmptyPlaceholder?: boolean;
  FRANDATUM?: string | null;
  FRANTID?: string | null;
  TILLTID?: string | null;
  TITEL?: string | null;
  AKTIVITETSTYP?: string | null;
  VERKSAMHETSTYP_ID?: string | number | null;
  GUDSTJANSTTYP_ID?: string | number | null;
  _verksamhetstypId?: string | null;
  _gudstjanstTypId?: string | null;
}

export type TPlaneringRequiredField =
  | 'FRANDATUM'
  | 'FRANTID'
  | 'TILLTID'
  | 'TITEL'
  | 'AKTIVITETSTYP'
  | 'VERKSAMHETSTYP_ID';

export type TPlaneringRequiredFieldErrors = Partial<
  Record<TPlaneringRequiredField, string>
>;

const isBlank = (value: unknown): boolean =>
  value == null || String(value).trim() === '';

const isAssocRequiredForAktivitetstyp = (
  aktivitetstyp: string | null | undefined
): boolean => aktivitetstyp === 'Gudstjänst' || aktivitetstyp === 'Övrigt';

const hasAssociationValue = (
  planeringRow: IPlaneringRequiredValidationRow
): boolean =>
  !isBlank(planeringRow.VERKSAMHETSTYP_ID) ||
  !isBlank(planeringRow.GUDSTJANSTTYP_ID) ||
  !isBlank(planeringRow._verksamhetstypId) ||
  !isBlank(planeringRow._gudstjanstTypId);

export const getPlaneringRequiredFieldErrors = (
  planeringRow: IPlaneringRequiredValidationRow
): TPlaneringRequiredFieldErrors => {
  const errors: TPlaneringRequiredFieldErrors = {};

  if (isBlank(planeringRow.FRANDATUM)) {
    errors.FRANDATUM = 'Fråndatum är obligatoriskt';
  }

  if (isBlank(planeringRow.FRANTID)) {
    errors.FRANTID = 'Fråntid är obligatoriskt';
  }

  if (isBlank(planeringRow.TILLTID)) {
    errors.TILLTID = 'Tilltid är obligatoriskt';
  }

  if (
    isAssocRequiredForAktivitetstyp(planeringRow.AKTIVITETSTYP) &&
    !hasAssociationValue(planeringRow)
  ) {
    errors.VERKSAMHETSTYP_ID = 'Verksamhetstyp/Gudstjänsttyp är obligatoriskt';
  }

  return errors;
};

export const validatePlaneringRequiredRows = (
  currentValues: unknown
): IFieldValidations => {
  if (!Array.isArray(currentValues)) {
    return [];
  }

  return currentValues.reduce<IFieldValidations>((validations, row) => {
    const planeringRow = row as IPlaneringRequiredValidationRow;

    // Skip placeholder row and booked activities (read-only rows).
    if (
      planeringRow.isEmptyPlaceholder ||
      planeringRow.source === 'aktivitet'
    ) {
      return validations;
    }

    const path = [String(planeringRow.id)];

    const fieldErrors = getPlaneringRequiredFieldErrors(planeringRow);
    (
      Object.entries(fieldErrors) as Array<[TPlaneringRequiredField, string]>
    ).forEach(([fieldName, message]) => {
      validations.push({
        fieldName,
        message,
        type: 'MissingValue',
        path,
      });
    });

    return validations;
  }, []);
};
